import { FC, useCallback } from 'react';

import { Jobseeker } from '@libs/models';
import { AutocompleteSearch, SearchParams } from '@carcareers/components';
import { jobseekerApi } from '@carcareers/store';

interface JobseekerSelectProps {
  name: string;
  disabled?: boolean;
}

export const JobseekerSelect: FC<JobseekerSelectProps> = ({ name, disabled = false }) => {
  const [searchJobseeker, { isLoading }] = jobseekerApi.endpoints.jobseekerSearch.useLazyQuery();

  const wrappedSearch = useCallback(async (params: SearchParams) => {
    try {
      const response = await searchJobseeker(params);
      return response.data;
    } catch (error) {
      console.error('Search error:', error);
      return { items: [] };
    }
  }, [searchJobseeker]);

  const transformResult = useCallback((item: Jobseeker) => {
    const displayName = item.user && (item.user.firstName || item.user.lastName)
      ? `${item.id} - ${item.user.firstName || ''} ${item.user.lastName || ''}`.trim()
      : `ID: ${item.id}`;
      
    return {
      label: displayName,
      value: item
    };
  }, []);

  return (
    <AutocompleteSearch
      name={name}
      loading={isLoading}
      disabled={disabled}
      search={wrappedSearch}
      label="Jobseeker"
      transformResult={transformResult}
    />
  );
};

export default JobseekerSelect;
